import { useState } from "react";

export default function BookSummaryTooltip({ children }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="relative inline-block align-middle">
      <button
        className="ml-2 text-indigo-500 hover:text-indigo-700 focus:outline-none"
        onClick={() => setOpen(o => !o)}
        aria-label="Show book summary"
      >
        ℹ️
      </button>
      {open && (
        <div
          className="absolute z-50 left-1/2 transform -translate-x-1/2 mt-3 bg-white p-5 shadow-xl rounded-xl text-sm w-[350px] max-w-xs border"
          style={{ minWidth: 260 }}
        >
          <div className="text-gray-900 font-bold mb-1">สรุปหนังสือ “อุปนิสัยที่ช่วยเพิ่มทั้งเวลาและเงินทอง”</div>
          <ol className="list-decimal pl-4 text-gray-700 space-y-1">
            <li>
              <b>อุปนิสัยด้านเวลา:</b> การเปลี่ยนเวลาที่เคย "สูญเปล่า" ให้กลายเป็น "เวลาที่มีมูลค่า" หรือ "ลงทุน" กับการเดินทาง: ใช้เวลาเดินทางบนรถไฟฟ้าหรือรถประจำทางในการฟังพอดแคสต์ความรู้, เป็นการเปลี่ยนเวลาเดินทางที่น่าเบื่อให้เป็นการลงทุนในตัวเอง ตัดสินใจให้เร็วขึ้น: ฝึกการตัดสินใจในเรื่องเล็กๆ น้อยๆ (เช่น จะกินอะไรเป็นมื้อกลางวัน) ภายใน 10 วินาที เพื่อลดการใช้พลังงานสมองและเวลาไปกับสิ่งที่ไม่สำคัญ
            </li>
            <li>
              <b>อุปนิสัยด้านเงิน:</b> ใช้จ่ายอย่างชาญฉลาดและมองเห็น "ต้นทุนค่าเสียโอกาส" จ่ายเงินเพื่อ "ซื้อเวลา": อย่าลังเลที่จะใช้เงินแก้ปัญหาที่เสียเวลา เพราะเวลาที่ได้คืนมาสามารถนำไปสร้างรายได้หรือพักผ่อนได้มากกว่า
            </li>
            <li>
              <b>อุปนิสัยชีวิต-งาน:</b> ปรับเปลี่ยนพฤติกรรมเล็กๆ น้อยๆ ที่ส่งผลกระทบเชิงบวกในระยะยาว, นอนให้เพียงพอ: การนอนคือการลงทุนในสุขภาพและประสิทธิภาพของวันถัดไป, ทบทวนเป้าหมายทุกสัปดาห์: ใช้เวลาสั้นๆ ในวันหยุดเพื่อทบทวนว่าสัปดาห์ที่ผ่านมาเราใช้เวลาและเงินไปกับสิ่งที่สอดคล้องกับเป้าหมายระยะยาวของเราหรือไม่
            </li>
          </ol>
          <div className="text-gray-400 mt-2 text-xs">
            * ทุกข้อคือ habits ที่ช่วยให้ชีวิตมี “ทั้งเวลาและเงิน” เพิ่มขึ้นพร้อมกัน
          </div>
        </div>
      )}
    </div>
  );
}